<template lang="pug">
div.sysgrao-chart-tooltip
  .sysgrao-chart-tooltip__header(v-if="title") {{ title }}
  .sysgrao-chart-tooltip__body(:class="{ 'sysgrao-chart-tooltip__body--no-title': !title }")
    .sysgrao-chart-tooltip__row(
      v-for="(item, index) in items",
      :key="item.key || `${item.label}-${index}`"
    )
      span.sysgrao-chart-tooltip__marker(:style="{ backgroundColor: item.color || '#748291' }")
      span.sysgrao-chart-tooltip__label {{ item.label }}:
      span.sysgrao-chart-tooltip__value {{ item.value }}
</template>

<script>
export default {
  name: "ChartTooltip",

  props: {
    title: { type: String, default: "" },
    items: { type: Array, default: () => [] }
  }
};
</script>

<style scoped>
.sysgrao-chart-tooltip {
  background: #fff;
  border: 1px solid #c9d5e4;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(15, 42, 77, 0.14);
  color: #173256;
  max-width: 360px;
  min-width: 220px;
  overflow: hidden;
}

.sysgrao-chart-tooltip__header {
  background: #dce4ef;
  border-bottom: 1px solid #c9d5e4;
  color: #173256;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  padding: 10px 14px;
  word-break: break-word;
}

.sysgrao-chart-tooltip__body {
  background: #fff;
  padding: 8px 14px;
}

.sysgrao-chart-tooltip__body--no-title {
  padding-top: 10px;
}

.sysgrao-chart-tooltip__row {
  align-items: center;
  display: flex;
  gap: 8px;
  min-width: 0;
  padding: 6px 0;
}

.sysgrao-chart-tooltip__marker {
  border-radius: 50%;
  flex: 0 0 12px;
  height: 12px;
  width: 12px;
}

.sysgrao-chart-tooltip__label {
  color: #173256;
  flex: 1 1 auto;
  font-size: 13px;
  line-height: 1.4;
  min-width: 0;
  word-break: break-word;
}

.sysgrao-chart-tooltip__value {
  color: #173256;
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  margin-left: auto;
  white-space: nowrap;
  text-align: right;
}
</style>
